import React from 'react';

import { FlattenedProductProps } from '../../../models';
import GridList from '../../sales-terminal/products/product-list/grid/grid-list';
import { VirtualizedGridContainer } from '../../resuable-ui/VirtualizedGridContainer/VirtualizedGridContainer';
import GridSettings from './grid.settings';

const { gap, overscan, gridBreakpoints, estimatedItemHeight } = GridSettings.GRID;

export const VirtualizeGrid = ({ products }: { products: FlattenedProductProps[] | null }) => {
	return (
		<VirtualizedGridContainer
			gap={gap}
			overscan={overscan}
			estimatedItemHeight={estimatedItemHeight}
			gridBreakpoints={gridBreakpoints}
		>
			{products?.map((product) => <GridList key={product._id} product={product} />) as React.ReactNode[]}
		</VirtualizedGridContainer>
	);
};

export default React.memo(VirtualizeGrid);
